const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID || "5d28ee50-ce4d-44fa-9f62-ce96c760cacc";
const MICROSOFT_TENANT = "common";
const REDIRECT_URI = `${window.location.origin}/microsoft/callback`;

export const signInWithMicrosoftPopup = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  return new Promise((resolve, reject) => {
    const authUrl = new URL(
      `https://login.microsoftonline.com/${MICROSOFT_TENANT}/oauth2/v2.0/authorize`
    );
    
    authUrl.searchParams.append("client_id", MICROSOFT_CLIENT_ID);
    authUrl.searchParams.append("response_type", "code");
    authUrl.searchParams.append("redirect_uri", REDIRECT_URI);
    authUrl.searchParams.append("scope", "openid profile email User.Read");
    authUrl.searchParams.append("response_mode", "query");
    authUrl.searchParams.append("prompt", "select_account");
    authUrl.searchParams.append("code_challenge", codeChallenge);
    authUrl.searchParams.append("code_challenge_method", "S256");

    const popup = window.open(
      authUrl.toString(),
      "Microsoft Sign In",
      "width=600,height=700,left=200,top=100"
    );

    if (!popup) {
      reject(new Error("Failed to open popup. Please allow popups for this site."));
      return;
    }

    const messageListener = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.data.type === "MICROSOFT_AUTH_SUCCESS") {
        window.removeEventListener("message", messageListener);
        popup.close();
        resolve({ 
          code: event.data.payload.code,
          codeVerifier 
        });
      } else if (event.data.type === "MICROSOFT_AUTH_ERROR") {
        window.removeEventListener("message", messageListener);
        popup.close();
        reject(new Error(event.data.error || "Microsoft authentication failed"));
      }
    };

    window.addEventListener("message", messageListener);

    const popupCheckInterval = setInterval(() => {
      if (popup.closed) {
        clearInterval(popupCheckInterval);
        window.removeEventListener("message", messageListener);
        reject(new Error("Authentication cancelled"));
      }
    }, 500);
  });
};

export const parseCodeFromQuery = () => {
  const params = new URLSearchParams(window.location.search);

  const code = params.get("code");
  const error = params.get("error");
  const errorDescription = params.get("error_description");

  if (error) {
    return { error, errorDescription };
  }

  if (!code) {
    return { error: "missing_code", errorDescription: "No authorization code received from Microsoft" };
  }

  return { code };
};

const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return base64URLEncode(array);
};

const generateCodeChallenge = (verifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  
  return window.crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
    return base64URLEncode(new Uint8Array(hashBuffer));
  });
};

const base64URLEncode = (buffer) => {
  const base64 = btoa(String.fromCharCode.apply(null, buffer));
  
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};


